const daResorts = {
  's': [
    {
      regionName: 'saint vincent',
      resortList: [
        {
          resortName: 'Sandals Saint Vincent',
          resortRegion: 'Argyle, Saint Vincent',
          value: 'ssv',
          selected: false,
        }
      ]
    },
    {
      regionName: 'curaçao',
      resortList: [
        {
          resortName: 'Sandals Royal Curaçao',
          resortRegion: 'Santa Barbara, Curaçao',
          value: 'scr',
          selected: false,
          slides: [
            'https://cdn.sandals.com/sandals/v12/images/resorts/src/home/main-slider/aerial-over-the-water-suites.jpg'
          ]
        }
      ]
    },
    {
      regionName: 'jamaica',
      resortList: [
        {
          resortName: 'Sandals Montego Bay',
          resortRegion: 'Montego Bay, Jamaica',
          value: 'smb',
          selected: false
        }, {
          resortName: 'Sandals Royal Caribbean',
          resortRegion: 'Montego Bay, Jamaica',
          value: 'src',
          selected: false
        }, {
          resortName: 'Sandals Negril',
          resortRegion: 'Negril, Jamaica',
          value: 'sng',
          selected: false
        }, {
          resortName: 'Sandals Royal Plantation',
          resortRegion: 'Ocho Rios, Jamaica',
          value: 'brp',
          selected: false
        }, {
          resortName: 'Sandals Ochi',
          resortRegion: 'Ocho Rios, Jamaica',
          value: 'sgo',
          selected: false
        }, {
          resortName: 'Sandals South Coast',
          resortRegion: 'Whitehouse, Jamaica',
          value: 'swh',
          selected: false
        }, {
          resortName: "Sandals Dunn's River",
          resortRegion: 'Ocho Rios, Jamaica',
          value: 'sdr',
          selected: false
        }
      ]
    }, {
      regionName: 'bahamas',
      resortList: [
        {
          resortName: 'Sandals Royal Bahamian',
          resortRegion: 'Nassau, Bahamas',
          value: 'srb',
          selected: false
        }
        // , {
        //   resortName: 'Sandals Emerald Bay',
        //   resortRegion: 'Great Exuma, Bahamas',
        //   value: 'seb',
        //   selected: false
        // }
      ],
    }, {
      regionName: 'grenada',
      resortList: [
        {
          resortName: 'Sandals Grenada',
          resortRegion: 'St. George\'s, Grenada',
          value: 'sls',
          selected: false
        }
      ]
    }, {
      regionName: 'antigua',
      resortList: [
        {
          resortName: 'Sandals Grande Antigua',
          resortRegion: 'St. John\'s, Antigua',
          value: 'sat',
          selected: false
        }
      ]
    }, {
      regionName: 'saint lucia',
      resortList: [
        {
          resortName: 'Sandals Regency La Toc',
          resortRegion: 'Castries, Saint Lucia',
          value: 'slu',
          selected: false
        }, {
          resortName: 'Sandals Grande St. Lucian',
          resortRegion: 'Castries, Saint Lucia',
          value: 'sgl',
          selected: false
        }, {
          resortName: 'Sandals Halcyon Beach',
          resortRegion: 'Castries, Saint Lucia',
          value: 'shc',
          selected: false
        }
      ]
    }, {
      regionName: 'barbados',
      resortList: [
        {
          resortName: 'Sandals Barbados',
          resortRegion: 'Saint Lawrence Gap, Barbados',
          value: 'sbd',
          selected: false
        }, {
          resortName: 'Sandals Royal Barbados',
          resortRegion: 'Saint Lawrence Gap, Barbados',
          value: 'sbr',
          selected: false
        }
      ]
    }
  ],
  'b': [
    {
      regionName: 'jamaica',
      resortList: [
        {
          resortName: 'Beaches Negril',
          resortRegion: 'Negril, Jamaica',
          value: 'bng',
          selected: 'false'
        }
      ]
    }, {
      regionName: 'Turks & Caicos',
      resortList: [
        {
          resortName: 'Beaches Turks & Caicos',
          resortRegion: 'Providenciales, Turks & Caicos',
          value: 'btc',
          selected: false
        }
      ],
    }
  ]
};

export default daResorts;



// WEBPACK FOOTER //
// ./js/modules/resortData/index.js